import { useCallback, useMemo } from "react"
import { useParams } from "react-router-dom"
import { useApplicationPermissionFirmwareConstraints } from "../../../../../../hooks/useApplicationPermissionFirmwareConstraints"
import { DimaFeatureShortNameEnum } from "../../../../../models/Authorization"
import { ApplicationPermissionFirmwareConstraintGet } from "../../../../../models/ApplicationPermissionFirmwareConstraint"
import { useDeleteConfirm } from "../../../../../../hooks/useDeleteConfirm"
import { deleteEntity } from "../../../../../utils/deleteEntity"
import { DiMaAddButton } from "../../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../../partials/EntityTab"

export function ApplicationPermissionFirmwareConstraints() {
  const { applicationId, permissionId } = useParams()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const {
    applicationPermissionFirmwareConstraints,
    isLoadingApplicationPermissionFirmwareConstraints,
  } = useApplicationPermissionFirmwareConstraints(applicationId, permissionId)

  const columns = [
    {
      field: "device",
      headerName: "Device",
      isLink: true,
      linkBasePath: `/applications/${applicationId}/permissions/${permissionId}/firmware-constraints`,
    },
    { field: "mainboardMinSoftwareVersion", headerName: "Mainboard Min SW Version" },
    { field: "hmiMinSoftwareVersion", headerName: "HMI Min SW Version" },
  ]

  const sorted = [...applicationPermissionFirmwareConstraints].sort(
    (a: ApplicationPermissionFirmwareConstraintGet, b: ApplicationPermissionFirmwareConstraintGet) =>
      `${a.device?.slaveId} - ${a.device?.name}`.localeCompare(
        `${b.device?.slaveId} - ${b.device?.name}`
      )
  )

  const rows = sorted.map((c: ApplicationPermissionFirmwareConstraintGet) => ({
    id: c.id,
    device: `${c.device?.slaveId} - ${c.device?.name}`,
    mainboardMinSoftwareVersion: c.mainboardMinSoftwareVersion,
    hmiMinSoftwareVersion: c.hmiMinSoftwareVersion,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/applications/${applicationId}/permissions/${permissionId}/firmware-constraints/create`}
        feature={DimaFeatureShortNameEnum.AM}
      />
    ),
    [applicationId, permissionId]
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() =>
          deleteEntity(
            `/applications/${applicationId}/permissions/${permissionId}/firmwareConstraints/${row.id}`
          )
        )
      }
    },
    [applicationId, permissionId, requestDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={columns}
        isLoading={isLoadingApplicationPermissionFirmwareConstraints}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
